import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "NOT_FOUND_PAGE", {
  TITLE: "Sorry, seems this content is not available anymore.",
  SUBTITLE:
    "Don't worry though, you will probably receive more amazings campaigns soon!",
});
